import React, { useEffect, useState } from "react";

const AppNavigator = () => {
  const [googleCode, setGoogleCode] = useState(null);
  const [facebookAccessToken, setFacebookAccessToken] = useState(null);

  useEffect(() => {
    // Check for Google auth code in query string
    const params = new URLSearchParams(window.location.search);
    const codeFromURL = params.get("code");

    // Check for Facebook auth in URL hash
    const hash = window.location.hash.substring(1); // Remove the # symbol
    const hashParams = new URLSearchParams(hash);
    const facebookAccessTokenFromURL = hashParams.get("access_token");

    if (codeFromURL) {
      // Google OAuth flow
      setGoogleCode(codeFromURL);

      // Auto redirect to app with Google code as token
      const appLink = `dinezi://authredirect?token=${encodeURIComponent(
        codeFromURL
      )}`;
      window.location.href = appLink;
    } else {
      // Facebook OAuth flow
      setFacebookAccessToken(facebookAccessTokenFromURL);

      // Auto redirect to app with Facebook access_token
      const appLink1 = `dinezi://authredirect?access_token=${encodeURIComponent(
        facebookAccessTokenFromURL
      )}`;
      window.location.href = appLink1;
    }
  }, [window.location.search, window.location.url]);

  const getManualLink = () => {
    if (googleCode) {
      return `dinezi://authredirect?token=${encodeURIComponent(googleCode)}`;
    } else if (facebookAccessToken) {
      return `dinezi://authredirect?access_token=${encodeURIComponent(
        facebookAccessToken
      )}`;
    }
    return "dinezi://authredirect";
  };

  const manualLink = getManualLink();

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #FF8C00, #4CAF50)",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          padding: "40px",
          textAlign: "center",
          width: "400px",
          boxShadow: "0px 6px 20px rgba(0,0,0,0.2)",
        }}
      >
        {/* Spinner */}
        <div
          style={{
            width: "50px",
            height: "50px",
            margin: "0 auto 20px",
            border: "6px solid #eee",
            borderTop: "6px solid #FF8C00",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />

        <h2 style={{ color: "#333", marginBottom: "10px" }}>
          Redirecting to <span style={{ color: "#FF8C00" }}>Dinezi</span> App...
        </h2>
        <p style={{ color: "#555", marginBottom: "20px" }}>
          If nothing happens, click below to open the app manually.
        </p>

        <a
          href={manualLink}
          style={{
            display: "inline-block",
            background: "#4CAF50",
            color: "#fff",
            padding: "12px 24px",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "bold",
            transition: "background 0.3s",
          }}
          onMouseOver={(e) => (e.target.style.background = "#43a047")}
          onMouseOut={(e) => (e.target.style.background = "#4CAF50")}
        >
          Open App Manually
        </a>
      </div>

      {/* CSS animation keyframes */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default AppNavigator;

// import React, { useEffect, useState } from "react";

// const AppNavigator = () => {
//   const [code, setCode] = useState(null);

//   useEffect(() => {
//     // Parse code from query string
//     const params = new URLSearchParams(window.location.search);
//     const codeFromURL = params.get("code");
//     if (codeFromURL) {
//       setCode(codeFromURL);

//       // Auto redirect to app
//       const appLink = `dinezi://authredirect?token=${encodeURIComponent(
//         codeFromURL
//       )}`;
//       window.location.href = appLink;
//     }
//   }, []);

//   const manualLink = code
//     ? `dinezi://authredirect?token=${encodeURIComponent(code)}`
//     : "dinezi://authredirect";

//   return (
//     <div
//       style={{
//         height: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         background: "linear-gradient(135deg, #FF8C00, #4CAF50)",
//         fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: "16px",
//           padding: "40px",
//           textAlign: "center",
//           width: "400px",
//           boxShadow: "0px 6px 20px rgba(0,0,0,0.2)",
//         }}
//       >
//         {/* Spinner */}
//         <div
//           style={{
//             width: "50px",
//             height: "50px",
//             margin: "0 auto 20px",
//             border: "6px solid #eee",
//             borderTop: "6px solid #FF8C00",
//             borderRadius: "50%",
//             animation: "spin 1s linear infinite",
//           }}
//         />

//         <h2 style={{ color: "#333", marginBottom: "10px" }}>
//           Redirecting to <span style={{ color: "#FF8C00" }}>Dinezi</span> App...
//         </h2>
//         <p style={{ color: "#555", marginBottom: "20px" }}>
//           If nothing happens, click below to open the app manually.
//         </p>

//         <a
//           href={manualLink}
//           style={{
//             display: "inline-block",
//             background: "#4CAF50",
//             color: "#fff",
//             padding: "12px 24px",
//             borderRadius: "8px",
//             textDecoration: "none",
//             fontWeight: "bold",
//             transition: "background 0.3s",
//           }}
//           onMouseOver={(e) => (e.target.style.background = "#43a047")}
//           onMouseOut={(e) => (e.target.style.background = "#4CAF50")}
//         >
//           Open App Manually
//         </a>
//       </div>

//       {/* CSS animation keyframes */}
//       <style>
//         {`
//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default AppNavigator;
